import React from 'react';

type SectionTone = 'paper' | 'mist' | 'sky' | 'ink';

const toneClasses: Record<SectionTone, string> = {
  paper: 'border-brand-100 bg-white',
  mist: 'border-brand-100 bg-brand-50/60',
  sky: 'border-brand-100 bg-brand-50',
  ink: 'border-brand-700 bg-brand-800 text-white',
};

interface HomeSectionFrameProps {
  id?: string;
  'aria-labelledby'?: string;
  tone?: SectionTone;
  className?: string;
  innerClassName?: string;
  children: React.ReactNode;
}

const HomeSectionFrame: React.FC<HomeSectionFrameProps> = ({
  id,
  'aria-labelledby': ariaLabelledBy,
  tone = 'paper',
  className = '',
  innerClassName = '',
  children,
}) => (
  <section
    id={id}
    aria-labelledby={ariaLabelledBy}
    className={`overflow-x-clip px-3 py-4 sm:px-5 sm:py-5 lg:px-8 lg:py-6 ${className}`}
    dir="rtl"
  >
    <div
      className={`relative mx-auto w-full max-w-7xl overflow-hidden rounded-2xl border-2 shadow-sm sm:rounded-3xl ${toneClasses[tone]}`}
    >
      <div
        className={`pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-l from-transparent to-transparent ${
          tone === 'ink' ? 'via-brand-400/40' : 'via-brand-300/40'
        }`}
        aria-hidden
      />
      <div className={`relative px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12 ${innerClassName}`}>
        {children}
      </div>
    </div>
  </section>
);

export default HomeSectionFrame;
